export type MapStyleKey = "dark" | "light" | "satellite";

export const MAP_THEME = {
  dark: {
    pin:         "#6366f1",
    pinStroke:   "rgba(255,255,255,0.88)",
    glow:        "rgba(99,102,241,0.70)",
    ring:        "rgba(99,102,241,0.38)",
    cardBg:      "#1a1a2e",
    fallback:    "linear-gradient(135deg,#818cf8 0%,#6366f1 50%,#4f46e5 100%)",
    spiderDot:   "#3b82f6",
    spiderLeg:   "rgba(99,179,237,0.7)",
    badge:       "rgba(0,0,0,0.72)",
    badgeBorder: "rgba(255,255,255,0.22)",
    badgeText:   "rgba(255,255,255,0.92)",
    cardBorder:  "rgba(255,255,255,0.82)",
  },
  light: {
    pin:         "#6366f1",
    pinStroke:   "rgba(255,255,255,0.72)",
    glow:        "rgba(99,102,241,0.22)",
    ring:        "rgba(99,102,241,0.14)",
    cardBg:      "rgba(255,255,255,0.72)",
    fallback:    "linear-gradient(135deg,#c7d2fe 0%,#a5b4fc 50%,#818cf8 100%)",
    spiderDot:   "#818cf8",
    spiderLeg:   "rgba(99,102,241,0.35)",
    badge:       "rgba(255,255,255,0.65)",
    badgeBorder: "rgba(0,0,0,0.07)",
    badgeText:   "rgba(0,0,0,0.55)",
    cardBorder:  "rgba(0,0,0,0.10)",
  },
  satellite: {
    pin:         "#f59e0b",
    pinStroke:   "rgba(0,0,0,0.70)",
    glow:        "rgba(245,158,11,0.60)",
    ring:        "rgba(245,158,11,0.35)",
    cardBg:      "#111",
    fallback:    "linear-gradient(135deg,#fbbf24 0%,#f59e0b 50%,#d97706 100%)",
    spiderDot:   "#f59e0b",
    spiderLeg:   "rgba(251,191,36,0.7)",
    badge:       "rgba(0,0,0,0.72)",
    badgeBorder: "rgba(255,255,255,0.22)",
    badgeText:   "rgba(255,255,255,0.92)",
    cardBorder:  "rgba(255,255,255,0.82)",
  },
} satisfies Record<MapStyleKey, object>;
